export default __webpack_public_path__ + "static/media/time.4c268fe0.svg";